import {AxiosRequestConfig} from 'axios';

import {
  API_GET_CASH_ENTRY,
  API_GET_DAY_REPORT_SALES_ATTACHEMNTS,
  API_GET_DROPS,
  API_GET_LOTTERY_PO,
  API_GET_LOTTERY_SALES_ENTRY,
  API_GET_MISC_PO,
  API_GET_MO_SALES,
  API_GET_SALES_ATTACHEMNTS,
  API_GET_SALES_COUPON,
  API_GET_SALES_VOID_ENTRY,
  API_POST_DELETE_COUPON_SALES,
  API_POST_DELETE_DROPS,
  API_POST_DELETE_LOTTERY_SALES,
  API_POST_DELETE_MISC_PO_SALES,
  API_POST_DELETE_MO_SALES,
  API_POST_UPSERT_CASH_ENTRY,
  API_POST_UPSERT_COUPON_SALES,
  API_POST_UPSERT_DROPS,
  API_POST_UPSERT_LOTTERY_PO,
  API_POST_UPSERT_LOTTERY_SALES_ENTRY,
  API_POST_UPSERT_MISC_PO,
  API_POST_UPSERT_MO_SALES,
  API_POST_UPSERT_VOID_SALES,
} from 'common/constants/apis';
import {ServerResponse} from 'common/interfaces';
import {ISalesAttachmentResp, ISalesUpdateResp} from 'common/interfaces/isales';
import {SalesEntryType} from 'common/interfaces/ishiftReport';
import UILogger from 'common/utils/logger';
import {
  DEFAULT_RETRY_CONFIG,
  SalesAttachmentTypeEnum,
} from '../common/constants/index';
import httpClient from './config';

export function postUpdateSalesEntry<T>(
  type: SalesEntryType,
  payload: T,
): Promise<ISalesUpdateResp<T> | undefined> {
  UILogger.info('Sending update sales entry request', payload, ',type:', type);
  let url = undefined;
  switch (type) {
    case 'cashEntry':
      url = API_POST_UPSERT_CASH_ENTRY;
      break;
    case 'lotterySales':
      url = API_POST_UPSERT_LOTTERY_SALES_ENTRY;
      break;
    case 'moSales':
      url = API_POST_UPSERT_MO_SALES;
      break;
    case 'lotteryPO':
      url = API_POST_UPSERT_LOTTERY_PO;
      break;
    case 'miscPO':
      url = API_POST_UPSERT_MISC_PO;
      break;
    case 'couponSales':
      url = API_POST_UPSERT_COUPON_SALES;
      break;
    case 'voids':
      url = API_POST_UPSERT_VOID_SALES;
      break;
    case 'dropsEntry':
      url = API_POST_UPSERT_DROPS;
      break;
  }
  if (!url) {
    return Promise.resolve(undefined);
  }

  return httpClient
    .post(url, payload, DEFAULT_RETRY_CONFIG as AxiosRequestConfig)
    .then(res => {
      UILogger.log('UPDATE sales entry response: ', res.data);
      return res.data;
    })
    .catch(error => {
      console.log('Error upserting sales entry:::', error.response.data);
      return error.response.data;
    });
}
export function postDeleteSalesEntry<T>(
  type: SalesEntryType,
  id: number,
): Promise<ServerResponse | undefined> {
  UILogger.info('Sending delete sales entry request: type:', type, id);
  let url = undefined;
  switch (type) {
    case 'moSales':
      url = API_POST_DELETE_MO_SALES.replace('{id}', id.toString());
      break;
    case 'couponSales':
      url = API_POST_DELETE_COUPON_SALES.replace('{id}', id.toString());
      break;
    case 'lotterySales':
      url = API_POST_DELETE_LOTTERY_SALES.replace('{id}', id.toString());
      break;
    case 'miscPO':
      url = API_POST_DELETE_MISC_PO_SALES.replace('{id}', id.toString());
      break;
    case 'dropsEntry':
      url = API_POST_DELETE_DROPS.replace('{id}', id.toString());
      break;
  }
  if (!url) {
    return Promise.resolve(undefined);
  }

  return httpClient
    .delete(url, DEFAULT_RETRY_CONFIG as AxiosRequestConfig)
    .then(res => {
      UILogger.log('delete sales entry response: ', res.data);
      return res.data;
    })
    .catch(error => {
      console.log('Error deleting sales entry:::', error.response.data);
      return error.response.data;
    });
}

export function getSalesEntry<T>(
  type: SalesEntryType,
  shiftId: number,
  version: number,
  pageNo: number = 1,
  pageSize: number = 100,
): Promise<ISalesUpdateResp<T> | undefined> {
  UILogger.info(
    'Sending get sales entry request. shiftId:',
    shiftId,
    'version:',
    version,
  );
  let url = undefined;
  switch (type) {
    case 'cashEntry':
      url = API_GET_CASH_ENTRY;
      break;
    case 'lotterySales':
      url = API_GET_LOTTERY_SALES_ENTRY;
      break;
    case 'moSales':
      url = API_GET_MO_SALES;
      break;
    case 'lotteryPO':
      url = API_GET_LOTTERY_PO;
      break;
    case 'miscPO':
      url = API_GET_MISC_PO;
      break;
    case 'couponSales':
      url = API_GET_SALES_COUPON;
      break;
    case 'voids':
      url = API_GET_SALES_VOID_ENTRY;
      break;
    case 'dropsEntry':
      url = API_GET_DROPS;
      break;
  }
  if (!url) {
    return Promise.resolve(undefined);
  }

  url = url
    ?.replace('{shiftId}', shiftId.toString())
    .replace('{version}', version.toString())
    .replace('{pageNo}', pageNo.toString())
    .replace('{pageSize}', pageSize.toString());
  UILogger.info('Sending get sales entry request. url:', url);
  return httpClient
    .get(url, DEFAULT_RETRY_CONFIG as AxiosRequestConfig)
    .then(res => {
      UILogger.log('GET sales entry response: ', res.data);
      return res.data;
    })
    .catch(error => {
      console.log('Error in getting sales entry:::', error.response.data);
      return error.response.data;
    });
}

export const getSalesAttachments = (
  type: SalesAttachmentTypeEnum,
  shiftId: number,
  version: number,
): Promise<ISalesAttachmentResp> => {
  UILogger.info(
    'getSalesAttachments::type:',
    type,
    ', version: ',
    version,
    ', shiftId:',
    shiftId,
  );
  return httpClient
    .get(
      API_GET_SALES_ATTACHEMNTS.replace('{shiftId}', shiftId.toString())
        .replace('{version}', version.toString())
        .replace('{type}', type),
      DEFAULT_RETRY_CONFIG as AxiosRequestConfig,
    )
    .then(res => {
      UILogger.log('getSalesAttachments response: ', res.data);
      return res.data;
    })
    .catch(error => {
      console.log('Error in getSalesAttachments:', error.response.data);
      return error.response;
    });
};

export const getDayReportAttachments = (
  type: SalesAttachmentTypeEnum,
  reportId: number,
): Promise<ISalesAttachmentResp> => {
  UILogger.info(
    'getDayReportAttachments::type:',
    type,
    ', version: ',
    reportId,
    ', reportId',
  );
  return httpClient
    .get(
      API_GET_DAY_REPORT_SALES_ATTACHEMNTS.replace(
        '{reportId}',
        reportId.toString(),
      ).replace('{type}', type),
      DEFAULT_RETRY_CONFIG as AxiosRequestConfig,
    )
    .then(res => {
      UILogger.log('getDayReportAttachments response: ', res.data);
      return res.data;
    })
    .catch(error => {
      console.log('Error in getDayReportAttachments:', error.response.data);
      return error.response;
    });
};
